//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";
import { Toast } from 'vant';
import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      searchValue: "",
      deliveries: [],
      formParams: {},
      showFormParamsSource: false,
      sourceActionsArr: [{code: "SOURCE_SHIP_INSTRUCTIONS", name: "配送指令"},
        {code: "SOURCE_MATCHE_PLATE", name: "配盘单"},
        {code: "SOURCE_PURCHASE_ORDER", name: "采购订单"},
        {code: "SOURCE_PURCHASE_ORDER_FOREIGN", name: "外贸订单"},
        {code: "SOURCE_ON_HAND", name: "自主送货"}],
      sourceActionsColumns: ["配送指令", "配盘单", "采购订单", "外贸订单", "自主送货"],
      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      refreshing: true,
      finished: false,
      loading: false,
      showMoreFormParams: false,
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
  },
  created() {
    this.requestDeliveries();
  },
  activated: function () {},
  methods: {
    //搜索 输入
    onInput() {
      this.deliveries.splice(0, this.deliveries.length); //清空数据
      this.onRefresh(); //重新请求
    },
    onRefresh() {
      //状态设置
      this.refreshing = true;
      this.loading = true;
      this.finished = false;
      //页数设置
      this.pageIndex = 1;
      this.onLoad();
    },
    onLoad() {
      this.requestDeliveries();
    },
    sourceOnClick() {

      this.showFormParamsSource = true
    },
    /**来源类型选择*/
    sourceActionsOnSelect(value, index) {
      this.showFormParamsSource = false
      this.formParams.sourceCode = this.sourceActionsArr[index].code
      this.formParams.sourceName = this.sourceActionsArr[index].name
    },
    /**重置高级查询框*/
    closeMoreParams() {
      //this.showMoreFormParams = false
      this.formParams = {}
    },
    /**按查询条件查询数据*/
    searchNoteList() {
      this.showMoreFormParams = false
      this.pageIndex = 1
      this.requestDeliveries()
    },
    requestDeliveries() {
      let _params = {
        lan: this.languageCode,
        pageIndex: this.pageIndex, //页数
        pageRows: this.pageRows,
        ...this.formParams
      }
      fetch.listMobileDeliveryNote(_params).then((res) => {
          console.log(res);
          //状态设置
          this.refreshing = false;
          this.loading = false;
          if (res.status === "S") {
            if (res.code === "S") {
              //清楚最后多余的数据
              const curPageIndex = res.page.curIndex; //页数
              const curIndex = (curPageIndex - 1) * this.pageRows; //index
              const lastLength = this.deliveries.length - curIndex; //剩余长度
              this.deliveries.splice(curIndex, lastLength);

              this.deliveries = this.deliveries.concat(res.data); //拼接数据
              if (this.deliveries.length < res.page.count) {
                this.pageIndex = res.page.nextIndex; //更新页数
              } else {
                //数据length不足row，没有更多数据，不继续往后加载
                this.finished = true;
              }
              // this.deliveries = res.data;
            }
          }
        });
    },
    onClickDelivery(delivery) {
      console.log(delivery);
      this.$router.push({
        path: "/Delivery",
        query: {
          noteHeaderId: delivery.noteHeaderId,
        },
      });
    },
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
  },
  watch: {},
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/page/srm/delivery/deliveryList.vue